export default __webpack_public_path__ + "static/media/process.bb851bfb.svg";